"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID ?? "";
const SHOW_POPUP = process.env.NEXT_PUBLIC_SHOW_CONSENT_POPUP === "true";

const CONSENT_KEY = "cookie-consent";
const CONSENT_EVENT = "cookie-consent-changed";

function hasConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

export function MicrosoftClarity() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (!CLARITY_ID) return;

    if (!SHOW_POPUP) {
      setShouldLoad(true);
      return;
    }

    if (hasConsent()) {
      setShouldLoad(true);
      return;
    }

    const handler = () => {
      if (hasConsent()) setShouldLoad(true);
    };

    window.addEventListener(CONSENT_EVENT, handler);
    return () => window.removeEventListener(CONSENT_EVENT, handler);
  }, []);

  if (!shouldLoad) return null;

  return (
    <Script
      id="microsoft-clarity"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window,document,"clarity","script","${CLARITY_ID}");
        `,
      }}
    />
  );
}
